import React from 'react';
import { Navigate } from 'react-router-dom';
import MenuPublico from './MenuPublico';

// La app instalada (PWA) es solo para el personal. Se revisa aquí además del start_url del
// manifest porque una instalación antigua puede seguir abriendo en "/" (en iPhone, siempre).
const isInstalledApp = () =>
    window.navigator.standalone === true
    || Boolean(window.matchMedia?.('(display-mode: standalone)').matches);

const PaginaInicio = () => (
    isInstalledApp() ? <Navigate to="/login" replace /> : <MenuPublico />
);

export default PaginaInicio;
